module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Gelterkinden-53e8c9bbdd9bd8807a2dd1d4ac6b52ad.svg";